import axiosInstance from "../utils/axios";

export const rccPaymentProofService = {
  getAllData: async (params = {}) => {
    const response = await axiosInstance.get(`/rcc-payment-proof/paginate`, { params });
    return response.data;
  },
  getById: async (id) => {
    const { data } = await axiosInstance.get(`/rcc-payment-proof/${id}`);
    return data;
  },
  verify: async (id, body) => {
    const { data } = await axiosInstance.patch(`/rcc-payment-proof/${id}/verify`, body);
    return data;
  },
  reject: async (id, body) => {
    const { data } = await axiosInstance.patch(`/rcc-payment-proof/${id}/reject`, body);
    return data;
  },
};
